export default __webpack_public_path__ + "static/media/6.f58504b5.png";